// Textes affichés d'un document (sous-titres, titres, étiquettes, questions…)
// : rendus par `MathText`, ils peuvent contenir des formules `$…$`. La
// validation les parcourt TOUS pour vérifier leurs `$` et leur LaTeX
// (`displayTextProblems`). Parcours par clé : un nouveau champ de texte
// affiché doit porter l'une de ces clés (test : `display-text.test.ts`).

import type { PathPart } from './issues';

export const DISPLAY_TEXT_KEYS: ReadonlySet<string> = new Set([
  'title',
  'summary',
  'label',
  'text',
  'prefix',
  'suffix',
  'prompt',
  'hint',
  'explanation',
  'choices',
]);

export interface DisplayText {
  path: PathPart[];
  text: string;
}

/** Tous les textes affichés du document, avec leur chemin. */
export function collectDisplayTexts(doc: unknown): DisplayText[] {
  const out: DisplayText[] = [];
  const walk = (value: unknown, path: PathPart[]) => {
    if (Array.isArray(value)) {
      value.forEach((v, i) => walk(v, [...path, i]));
      return;
    }
    if (value === null || typeof value !== 'object') return;
    for (const [key, v] of Object.entries(value)) {
      const p = [...path, key];
      if (!DISPLAY_TEXT_KEYS.has(key)) walk(v, p);
      else if (typeof v === 'string') out.push({ path: p, text: v });
      else if (Array.isArray(v))
        v.forEach((t, i) => typeof t === 'string' && out.push({ path: [...p, i], text: t }));
    }
  };
  walk(doc, []);
  return out;
}
